(function() { /* Start dojo-webpack-plugin extensions */
		function mix(dest, src) { // eslint-disable-line no-unused-vars
			for(var n in src) dest[n] = src[n];
			return dest;
		}

		function toUrl(name, referenceModule) {
			return loaderScope.require.toUrl(name, referenceModule);
		}

		function toAbsMid(name, referenceModule) {
			return loaderScope.require.toAbsMid(name, referenceModule);
		}

		// dojo require function.
		function req(config, dependencies, callback) {
			return contextRequire(config, dependencies, callback, 0, req);
		};

		function createContextRequire(module) { // eslint-disable-line no-unused-vars
			if (!module) return req;
			var moduleId = module.absMid;
			if (!moduleId && req.absMidsById[module.id]) {
				moduleId = req.absMidsById[module.id];
			}
			if (!moduleId) return req;
			var result = function(a1, a2, a3) {
				return contextRequire(a1, a2, a3, moduleId, req);
			};
			for (var p in req) {
				if (req.hasOwnProperty(p)) {
					result[p] = req[p];
				}
			}
			result.toUrl = function(name) {
				return toUrl(name, moduleId ? {mid: moduleId} : null);
			};
			result.toAbsMid = function(name) {
				return toAbsMid(name, moduleId ? {mid: moduleId} : null);
			};

			if (req.undef) {
				result.undef = function(mid) {
					req.undef(mid, moduleId);
				};
			}
			return result;
		}

		function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
			for (var s in absMids) {
				req.absMids[s] = absMids[s];
				if (!req.absMidsById[absMids[s]]) {
					req.absMidsById[absMids[s]] = s;
				}
			}
		}

		function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
			// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
			// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
			// using the currently defined features returns a module id, or else undefined.

			var has = findModule("dojo/has", null, false);
			var id = has.normalize(expr, function(arg){return arg;});
			return id && __webpack_require__(id) || undefined;
		}

		function findModule(mid, referenceModule, noInstall, asModuleObj) {
			mid = mid.split("!").map(function(segment) {
				var isRelative = segment.charAt(0) === '.';
				if(isRelative && !referenceModule){
					return segment;
				}
				return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
			}).join("!");
			var result;
			if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
				if (noInstall) {
					var module = __webpack_module_cache__[req.absMids[mid]];
					result = module && (asModuleObj ? module : module.exports);
				} else {
					result = __webpack_require__(req.absMids[mid]);
				}
			}
			if (!result) {
				throw new Error('Module not found: ' + mid);
			}
			return result;
		}

		function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
			if (webpackModule.absMid) return webpackModule;  // Already converted
			var result = {i:webpackModule.id};
			var id = req.absMidsById[webpackModule.id];
			if (id) {
				result.id = result.absMid = id;
			}
			Object.defineProperty(result, "exports", {
				get: function() { return webpackModule.exports;},
				set: function(value) {webpackModule.exports = value;},
				enumerable: true,
				configurable: true
			});
			return result;
		}

		function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
			var type = ({}.toString).call(a1);
			if (type === '[object String]') {
				// a3 is passed by require calls injected into dependency arrays for dependencies specified
				// as identifiers (vs. string literals).
				var noInstall = !(a3 === false);
				var m = findModule(a1, referenceModule, noInstall);
				if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
					throw new Error('Module not found: ' + a1);
				}
				return m;
			} else if (type === '[object Object]') {
				throw new Error('Require config is not supported by WebPack');
			}
			if (type === '[object Array]') {
				var modules = [], callback = a2, errors = [];
				a1.forEach(function (mid) {
					try {
						modules.push(findModule(mid, referenceModule));
					} catch (e) {
						errors.push({mid: mid, error: e});
					}
				});
				if (errors.length === 0) {
					if (callback) {
						if (false && isDefinePromise(modules)) { // eslint-disable-line no-undef
							Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
								callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
							}.bind(this)).catch(function(err){console.error(err);});
						} else {
							callback.apply(this, modules);
						}
					}
				} else {
					var error = new Error("findModules");
					error.src = "dojo-webpack-plugin";
					error.info = errors;
					req.signal("error", error);
				}
				return req;
			} else {
				throw new Error('Unsupported require call');
			}
		}
		req.toUrl = toUrl;
		req.toAbsMid = toAbsMid;
		req.absMids = {};
		req.absMidsById = [];
		req.async = 1;
	var globalObj = this||window;
	registerAbsMids({
		// "!!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./style.css" = 80133
		// "./lib/usng.js?raw" = 3065
		// "./lib/gridlines?raw" = 82425
		// "./lib/latlng_layer?raw" = 37182
		// "./lib/utm?raw" = 59288
		// "./lib/leaflet.pattern-src?raw" = 45618
		"idis/control/Locator":32702,
		"idis/consts/QUERY":62257,
		"idis/model/UserInfo":93496,
		"idis/consts/USER_TYPE":42970,
		"idis/service/Requester":54887,
		"idis/consts/CONTENT_TYPE":49468,
		"idis/util/TypeUtils":9654,
		"app/config":14992,
		"app/consts/PUB_STATUS":40563,
		"idis/consts/ACL":75746,
		"idis/view/parser":70514,
		"idis/control/Router":76133,
		"idis/view/dialog/ConfirmDialog":73224,
		"dojo/text!idis/view/dialog/templates/confirmActionBar.html":56228,
		"idis/view/dialog/_OKDialogMixin":37974,
		"dojo/text!idis/view/dialog/templates/infoActionBar.html":3839,
		"idis/view/form/Button":50947,
		"idis/view/dialog/IdisDialog":3416,
		"idis/view/dialog/_DialogContentMixin":55088,
		"idis/util/polyfill":33089,
		"app/control/AdisRouter":33490,
		"src/modules/index.js":94894,
		"src/modules/login":19705,
		"app/login/view/LoginPage":16236,
		"dojo/text!app/login/view/templates/LoginPage.html":53681,
		"idis/view/page/_PageBase":36074,
		"idis/view/_IdisWidgetBase":99982,
		"idis/model/LinkUrl":66268,
		"app/login/view/PasswordResetDialog":3872,
		"dojo/text!app/login/view/templates/PasswordResetDialog.html":60298,
		"idis/view/dialog/DialogChain":21205,
		"idis/view/Loader":64802,
		"idis/error/InvalidArgumentException":25123,
		"app/login/view/TrainingLoginPage":10377,
		"dojo/text!app/login/view/templates/TrainingLoginPage.html":47104,
		"src/modules/notice":53462,
		"app/notice/view/NoticePage":19327,
		"dojo/text!app/notice/view/templates/NoticePage.html":22970,
		"idis/store/IdisRest":54964,
		"idis/util/FormUtils":25590,
		"idis/view/form/DateTimeInput":26859,
		"idis/view/form/_NamedMixin":18724,
		"idis/view/form/DateInput":87318,
		"idis/view/form/_DateTimeInputMixin":56496,
		"idis/view/form/TimeInput":5449,
		"idis/view/form/AclButton":42307,
		"app/notice/view/form/NoticeTypeSelect":98310,
		"app/notice/NoticeTypeModel":63495,
		"app/notice/view/NoticeDetailPage":51220,
		"dojo/text!app/notice/view/templates/NoticeDetailPage.html":98589,
		"app/notice/view/_LinkInsertMixin":28892,
		"idis/view/form/CheckGroup":31383,
		"idis/view/form/_OptionGroupMixin":44070,
		"idis/util/ArrayUtils":45439,
		"app/notice/view/NoticeGrid":3732,
		"idis/view/grid/IdisGrid":79905,
		"idis/view/grid/helper":8674,
		"idis/util/DateUtils":65815,
		"app/notice/NoticeFormatter":22998,
		"idis/util/StringUtils":17906,
		"app/notice/view/NoticeTypeColumn":60705,
		"idis/view/LazyNode":73897,
		"app/notice/view/NoticeTypePage":49774,
		"dojo/text!app/notice/view/templates/NoticeTypePage.html":2418,
		"app/notice/view/NoticeTypeItem":24137,
		"dojo/text!app/notice/view/templates/NoticeTypeItem.html":45557,
		"app/notice/view/NoticeRegisterPage":32769,
		"dojo/text!app/notice/view/templates/NoticeRegisterPage.html":65649,
		"idis/view/form/RadioGroup":56531,
		"dojo/query!css2":85554,
		"src/modules/signage":92873,
		"app/signage/SignageAdminPage":14425,
		"dojo/text!app/signage/templates/SignageAdminPage.html":17743,
		"app/signage/_SignageDialogBase":30402,
		"idis/view/dialog/InfoDialog":79680,
		"app/util/DateFormatter":66382,
		"app/AppUtils":88741,
		"app/signage/consts/DisplayTypeCode":70352,
		"app/signage/consts/DisplayType":59615,
		"app/signage/SignageAdminPageGrid":83665,
		"idis/view/grid/IdisSelector":84335,
		"app/signage/SignageRegisterDialog":85302,
		"dojo/text!app/signage/templates/SignageRegisterDialog.html":6412,
		"app/signage/DisplayType":28305,
		"idis/view/form/WordCountTextarea":44566,
		"idis/view/form/WordCountTextBox":32561,
		"app/view/form/MunicipalitySelector":66624,
		"idis/view/form/TreeSelector":31533,
		"dojo/text!idis/view/form/templates/TreeSelector.html":53637,
		"idis/view/tree/IdisTree":79069,
		"app/model/Municipality":90560,
		"idis/store/CacheStoreModel":34423,
		"idis/store/_FullNameModelMixin":94436,
		"idis/store/_PromiseModelMixin":17710,
		"idis/store/CacheTreeRest":96619,
		"idis/store/CacheRest":74951,
		"idis/store/CachelessJsonRest":54378,
		"app/model/NoPrefMunicipality":34503,
		"app/view/form/OrganizationSelector":89076,
		"app/model/Organization":37775,
		"app/view/form/DisasterSelector":76766,
		"app/model/DisasterInfo":40145,
		"app/view/form/EarthQuakeSelector":11159,
		"app/model/EarthQuake":61381,
		"app/signage/damagetype/DamageTypeSelector":35615,
		"dojo/text!app/signage/damagetype/templates/DamageTypeSelector.html":47771,
		"app/damage/consts/DamageType":18669,
		"app/signage/damagetype/DamageTypeDialog":69715,
		"dojo/text!app/signage/damagetype/templates/DialogContent.html":52627,
		"app/signage/damagetype/DamageTypeGrid":53578,
		"app/view/form/CustomizableMunicipalitySelector":46190,
		"app/view/form/MunicipalityListSelector":2233,
		"app/signage/SignageDetailDialog":26920,
		"dojo/text!app/signage/templates/SignageDetailDialog.html":82577,
		"app/signage/display/SignageDisasterPreventionStatusPage":72885,
		"dojo/text!app/signage/display/templates/SignageDisasterPreventionStatusPage.html":75805,
		"app/signage/_SignageBase":23229,
		"app/signage/SignageMapSettingPage":6205,
		"dojo/text!app/signage/templates/SignageMapSettingPage.html":36235,
		"idis/map/IdisMap":27043,
		"app/model/LayerStore":85475,
		"idis/store/JsonLayerStore":15090,
		"idis/consts/STORAGE_KEY":11565,
		"app/control/LayerControl":90552,
		"app/model/RainfallObservatoryStore":17721,
		"app/model/RiverLevelObservatoryStore":60328,
		"app/model/TideLevelObservatoryStore":22532,
		"app/model/CrisisManageRiverLevelObsavatoryStore":31318,
		"app/observation/map/ObservationLayer":92561,
		"app/model/ObservatoryManager":69978,
		"app/observation/LatestData":47482,
		"app/shelter/map/ShelterLayer":91210,
		"app/shelter/ShelterUtils":85376,
		"app/observation/map/SedimentWarningLayer":74892,
		"app/observation/map/ObservationRasterLayer":6394,
		"app/observation/define/TileUrl":12586,
		"app/observation/map/Grib2MeshLayer":95460,
		"app/observation/map/ObservationRasterTMSLayer":59156,
		"app/map/layer/SedimentMeshMapPopup":3054,
		"dojo/text!app/map/layer/templates/SedimentMeshMapPopup.html":54027,
		"app/map/layer/ClickableRasterTileLayer":50841,
		"app/map/layer/CalcMeshCode":80493,
		"app/map/layer/MultipleGeoJsonLayer":19097,
		"app/observation/map/TimeSeriesGeoJsonLayer":56910,
		"app/map/layer/StyleLoader":76987,
		"app/map/snakeline/SnakelineGuideLayerContainer":89333,
		"app/map/layer/MunicipalityLayer":45368,
		"app/map/snakeline/SnakelineMeshLayer":50576,
		"app/map/snakeline/VectorMeshLayer":84981,
		"idis/control/GeoJSONTileLayer":84938,
		"app/map/snakeline/SnakelineDataDirectory":54949,
		"app/map/snakeline/MeshColor":30995,
		"app/map/snakeline/KeyName":98034,
		"app/consts/LAYER_ID":14888,
		"idis/util/storage/LocalStorage":79026,
		"idis/util/storage/StorageManager":49217,
		"idis/view/draw/HistoricalMap":31420,
		"idis/view/draw/DrawFeatureGroup":74693,
		"idis/view/draw/_addCloneFuncs":75123,
		"idis/view/draw/CustomDivIcon":71217,
		"idis/view/draw/CustomIcon":6862,
		"idis/view/draw/_SetStyleMixin":56100,
		"idis/view/draw/_DrawUtil":84269,
		"idis/map/BaseLayerOptions":80477,
		"dojo/text!idis/map/templates/esriAttribution.html":82947,
		"dojo/text!idis/map/templates/gsiAttribution.html":54423,
		"idis/map/BaseLayerUtils":44737,
		"idis/map/SCALE":91245,
		"app/map/LayerPane":8394,
		"dojo/text!app/map/templates/LayerPane.html":70243,
		"app/map/LayerPaneTree":9890,
		"idis/view/tree/CheckTree":70109,
		// "app/map/consts/ExclusiveLayer.json" = 43005
		"app/map/Layers":92621,
		"app/model/Layer":14883,
		"idis/store/JsonLayerModel":8377,
		"app/map/LayerPaneTreeNode":72910,
		"app/map/detail/DetailMap":96849,
		"app/map/detail/DumpDetail":31637,
		"dojo/text!app/map/detail/templates/DumpDetail.html":23154,
		"app/map/detail/DrawDetail":65594,
		"dojo/text!app/map/detail/templates/DrawDetail.html":78186,
		"app/map/detail/LayerPropList":6156,
		"idis/service/GeoService":92710,
		"app/map/detail/consts/LayerPropColumnMap":53613,
		"app/map/detail/DrawDetailGrid":97412,
		"app/view/form/PubStatusSelector":95530,
		"app/model/PubStatus":8936,
		"app/view/form/ZoomLevelSelector":16341,
		"app/map/detail/LayerPropGrid":52606,
		"app/map/detail/DamageReportDetail":81718,
		"dojo/text!app/map/detail/templates/DamageReportDetail.html":95803,
		"app/map/detail/DamageReportDetailGrid":31989,
		"app/map/detail/LayerPropDetail":87325,
		"dojo/text!app/map/detail/templates/LayerPropDetail.html":60272,
		"app/map/detail/PhotoUploadDetail":42452,
		"dojo/text!app/map/detail/templates/PhotoUploadDetail.html":52399,
		"app/map/detail/PhotoUploadDetailGrid":47358,
		"app/map/detail/TrafficRegulationDetail":80304,
		"dojo/text!app/map/detail/templates/TrafficRegulationDetail.html":54083,
		"app/map/detail/TrafficRegulationDetailGrid":13963,
		"app/map/detail/DefinedByJson":48566,
		"dojo/text!app/map/detail/templates/DefinedByJson.html":20229,
		"app/map/detail/DefinedByJsonGrid":23085,
		"app/map/legend/LegendPane":91579,
		"dojo/text!app/map/legend/templates/LegendPane.html":54292,
		"app/map/legend/_LegendPaneBase":33736,
		"app/map/legend/LEGEND_LIST":36252,
		"app/map/legend/GridLegendPane":22517,
		"app/signage/display/SignageDamageOverviewPage":58478,
		"dojo/text!app/signage/display/templates/SignageDamageOverviewPage.html":16920,
		"app/signage/display/SignageDamageListPage":90663,
		"dojo/text!app/signage/display/templates/SignageDamageListPage.html":20546,
		"app/signage/display/SignageShelterOverviewPage":72197,
		"dojo/text!app/signage/display/templates/SignageShelterOverviewPage.html":42001,
		"app/signage/display/SignageShelterListPage":3590,
		"dojo/text!app/signage/display/templates/SignageShelterListPage.html":80952,
		"app/signage/display/SignageEvacOrderOverviewPage":27067,
		"dojo/text!app/signage/display/templates/SignageEvacOrderOverviewPage.html":9798,
		"app/signage/display/SignageEvacOrderHistory":14110,
		"dojo/text!app/signage/display/templates/SignageEvacOrderHistory.html":64366,
		"app/signage/display/SignageMapPage":10997,
		"dojo/text!app/signage/display/templates/SignageMapPage.html":15885,
		"app/signage/display/SignageThematicEvacPage":57247,
		"dojo/text!app/signage/display/templates/SignageThematicEvacPage.html":41827,
		"app/signage/display/SignageChronologyOverviewPage":65680,
		"dojo/text!app/signage/display/templates/SignageChronologyOverviewPage.html":10986,
		"app/signage/display/SignageChronologyListPage":86457,
		"dojo/text!app/signage/display/templates/SignageChronologyListPage.html":27230,
		"app/signage/display/SignageDisasterPreventionOverviewPage":51388,
		"dojo/text!app/signage/display/templates/SignageDisasterPreventionOverviewPage.html":4017,
		"app/signage/display/SignageLifelineOverviewPage":74597,
		"dojo/text!app/signage/display/templates/SignageLifelineOverviewPage.html":28639,
		"app/model/Region":64615,
		"app/signage/display/SignageObservationOverviewPage":23543,
		"dojo/text!app/signage/display/templates/SignageObservationOverviewPage.html":18146,
		"app/signage/display/SignageEarthquakeStatusPage":51932,
		"dojo/text!app/signage/display/templates/SignageEarthquakeStatusPage.html":79075,
		"app/signage/display/SignageWeatherInfoStatusPage":5798,
		"dojo/text!app/signage/display/templates/SignageWeatherInfoStatusPage.html":8037,
		"app/util/AreaUtil":25638,
		"src/modules/view":25756,
		"app/view/page/MonitoringPage":22182,
		"dojo/text!app/view/page/templates/MonitoringPage.html":67749,
		"idis/view/form/MunicipalitySelectForm":15916,
		"dojo/text!idis/view/form/templates/MunicipalitySelectForm.html":81496,
		"app/view/form/RegionSelector":46808,
		"app/map/baselayer/BaseLayerPane":19654,
		"dojo/text!app/map/baselayer/templates/BaseLayerPane.html":86371,
		"app/map/AddressPanel":59967,
		"dojo/text!app/map/templates/AddressPanel.html":60951,
		"app/map/islandPanel/IslandPanel":68727,
		"dojo/text!app/map/islandPanel/templates/IslandPanel.html":35600,
		"app/map/TimestampsPanel":39992,
		"dojo/text!app/map/templates/TimestampsPanel.html":7528,
		"app/control/AdisTrainingRouter":43001,
		"app/control/SignageControl":1858,
		"app/view/Header":22732,
		"dojo/text!app/view/templates/Header.html":97882,
		"app/view/PopupAlert":12727,
		"idis/view/form/GeocodingForm":46982,
		"dojo/text!idis/view/form/templates/GeocodingForm.html":486,
		"app/view/Menu":56983,
		"dojo/text!app/view/templates/Menu.html":32921,
		"app/view/TrainingHeader":95168,
		"dojo/text!app/view/templates/TrainingHeader.html":52705,
		"app/view/SignageHeader":54996,
		"dojo/text!app/view/templates/SignageHeader.html":11476
		// "/tmp/tmp-169gqkGZODuaGrR/dojo/dojo.js" = 51649
	});

	globalObj.require = req;
		(self["webpackChunkadis"] = self["webpackChunkadis"] || []).registerAbsMids = registerAbsMids;

	// expose the Dojo compatibility functions as a properties of __webpack_require__
	if (__webpack_require__.dj && __webpack_require__.dj.name !== 'dojo-webpack-plugin') throw new Error("__webpack_require__.dj name collision.")
	__webpack_require__.dj = {
		name: 'dojo-webpack-plugin',
		r: req,
		c: createContextRequire,
		m: dojoModuleFromWebpackModule,
		h: resolveTernaryHasExpression,
	};
	var loaderScope = Object.create(globalObj, {
	   document:{value: globalObj.document},
	});
	Object.defineProperties(loaderScope, {
	   window:{value:loaderScope},
	   global:{value:loaderScope}
	});
	loaderScope.define = loaderScope.require = undefined
	globalObj.dojoConfig = globalObj.dojoConfig || {}
	var userConfig = mix(globalObj.dojoConfig, ({'baseUrl':'.','deps':['src/index'],'async':true,'has':({'dojo-config-api':0})}));
	var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1}),'paths':({'js':'src','theme':'theme'}),'pathsMapProg':[['theme','theme',/^theme(\/|$)/,5],['js','src',/^js(\/|$)/,2]],'packs':({'dojo':({'main':'main','name':'dojo','location':'/dojo','lib':'.'}),'dijit':({'main':'main','name':'dijit','location':'/dijit','lib':'.'}),'dojox':({'main':'main','name':'dojox','location':'/dojox','lib':'.'}),'dstore':({'main':'main','name':'dstore','location':'/dojo-dstore','lib':'.'})}),'aliases':[],'mapProgs':[],'cacheBust':undefined,'modules':({}),'cache':({})});
	var dojoLoader = __webpack_require__(51649);
	dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
	loaderScope.require.baseUrl = "./";
	Object.keys(loaderScope.require.packs).forEach(function(key) {
		var pkg = loaderScope.require.packs[key];
		if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
		    || pkg.main.split('/').reduce(function(acc, pathComp) {
					if (acc < 0 || pathComp === '.') return acc;
					return (pathComp === '..' ? --acc : ++acc);
				}, 0) <= 0) // main path is outside package
				&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
		) {
			pkg.realMain = pkg.main;
			pkg.main = '';
		}
	});
	function toAbsMid(name, referenceModule) {
		var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
		if (absMid.indexOf('/') === absMid.length-1) {
			var pkgName = absMid.substring(0, absMid.length-1);
			var pkg = loaderScope.require.packs[pkgName];
			if (pkg && pkg.realMain) {
				absMid = pkgName;
			}
		}
		return absMid;
	}
	function toUrl(name, referenceModule) {
		var url = loaderScope.require.originalToUrl(name, referenceModule);
		var pkg = loaderScope.require.packs[name];
		if (pkg && pkg.realMain) {
			var parts = url.split('?');
			if (/(^\/)|(\:)/.test(pkg.realMain)) {
				// absolute URL
				parts[0] = pkg.realMain;
			} else {
				// relative URL
				parts[0] = parts[0] + '/' + pkg.realMain;
			}
			url = parts.join('?');
		}
		return url;
	}
	loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
	loaderScope.require.originalToUrl = loaderScope.require.toUrl;
	loaderScope.require.toAbsMid = toAbsMid;
	loaderScope.require.toUrl = toUrl;
	['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
	var absMidsWaiting = globalObj["webpackChunkadis"].absMidsWaiting;
	if (absMidsWaiting) {
	   absMidsWaiting.forEach(registerAbsMids);
	   delete globalObj["webpackChunkadis"].absMidsWaiting;
	}
})(); /* End dojo-webpack-plugin extensions */